
import {first} from 'rxjs/operators';
import { Component, OnInit, Input, Inject } from "@angular/core";

import { Observable } from "rxjs";

import { FlowTemplate, State, Transition, SideEffect, Rule } from "../../../../common/models/flow.dto";
import { GroupStub } from "../../../../admin/models/group.model";
import { genId } from "../../../../core/services/genId";
import { GroupService } from "../../../../admin/services/group.service";
import { WorkOrderType } from "../../../../common/models/work-order.model";
import { SideEffectData, SIDE_EFFECT_DATA_TOKEN } from "./models/types";


@Component({
    selector: "side-effect-review-tasks",
    templateUrl: "side-effect-review-tasks.component.html",
    standalone: false
})

export class SideEffectReviewTasksComponent implements OnInit {
    availableWorkOrderTypes = [
        { id: undefined, text: "..." },
        { id: WorkOrderType.AcceptApplication, text: "Application Acceptance" },
        { id: WorkOrderType.ReviewExpedite, text: "Expedited Status Review" },
        { id: WorkOrderType.Review, text: "Review" },
        { id: WorkOrderType.CertifiedMail, text: "Certified Mail" },
        { id: WorkOrderType.StandardMail, text: "Standard Mail" }
    ];

    selectedWorkOrderType: WorkOrderType = WorkOrderType.Review;
    sideEffect: SideEffect;
    template: FlowTemplate;
    transition: Transition;
    availableGroups = new Array<GroupStub>();
    availableTransitions = new Array<Transition>();
    dateOptions = [{ id: "select", text: "..." }, { id: "time", text: "Set Timeframe" }, { id: "expression", text: "Custom Expression" }];
    defaultDateOption: string = "select";
    selectedReview: any;
    selectedReviewTransition: Transition;
    showWarning: boolean = false;
    state: State;

    constructor(
        public readonly groupService: GroupService,
        @Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData) {
        this.sideEffect = data.sideEffect;
        this.template = data.template;
        this.transition = data.transition;
    }

    ngOnInit() {
        if (!this.sideEffect.configuration.dateType) {
            this.sideEffect.configuration.dateType = this.defaultDateOption;
        }
        if (!this.sideEffect.configuration.rule) {
            this.sideEffect.configuration.rule = this.generateDefaultRule();
        }
        if (!this.sideEffect.configuration.timeFrame) {
            this.sideEffect.configuration.timeFrame = 0;
        }
        this.getAvailableGroups();
        this.getAvailableTransitions();

        //For legacy reasons, iterate through all our current reviews, and set the transition name on them if it's not already set
        for (let i = 0; i < this.sideEffect.configuration.reviews.length; i++) {
            if (!this.sideEffect.configuration.reviews[i].transitionName) {
                let transition = this.state.transitions.find(t => t.key === this.sideEffect.configuration.reviews[i].transition);
                this.sideEffect.configuration.reviews[i].transitionName = transition.name;
            }
        }
    }

    getAvailableGroups(): void {
        this.availableGroups.push({ id: "-1", displayName: "..." });
        (this.groupService.get({ stubs: true }) as Observable<GroupStub[]>).pipe(
            first())
            .subscribe(groups => {
                this.availableGroups = groups;
            });
    }

    getAvailableTransitions(): void {
        this.state = this.template.states.find(s => s.key === this.transition.toStateKey);
        this.availableTransitions.push({ key: "-1", name: "...", outgoingRules: [], sideEffects: [] });
        if (this.state) {
            for (let i = 0; i < this.state.transitions.length; i++) {
                const transition = this.state.transitions[i];
                if ((this.state.key === transition.fromStateKey) &&
                    (transition.fromStateKey === transition.toStateKey)) {
                    this.availableTransitions.push(transition);
                } else {
                    const destination = this.template.states.find(s => s.key === transition.toStateKey);
                    if (destination) {
                        this.availableTransitions.push(transition);
                    }
                }
            }
        }
    }

    changeTransition(transitionId: string): void {
        if (this.state) {
            this.selectedReviewTransition = this.state.transitions.find(t => t.key === transitionId);
            this.selectedReview.transitionName = this.selectedReviewTransition.name;
            let existing = 0;
            this.sideEffect.configuration.reviews.forEach(r => {
                if (r.transition === transitionId) {
                    existing = existing + 1;
                }
            });
            this.showWarning = existing > 1;
        }
    }

    changeDateType(): void {
        this.sideEffect.configuration.timeFrame = 0;
        this.sideEffect.configuration.rule = this.generateDefaultRule();
    }

    addReview(): void {
        this.showWarning = false;
        const reviewTitle = `Review Level ${this.sideEffect.configuration.reviews.length + 1}`;
        this.selectedReview = {
            id: genId(),
            blockOnOtherOustandingWorkOrders: false,
            title: reviewTitle,
            group: -1,
            transition: "-1",
            workOrderType: WorkOrderType.Review,
            chiefOrderGroup: false
        };

        if (this.sideEffect.configuration.reviews.length > 0)
            this.selectedReview.parentTaskId = this.sideEffect.configuration.reviews[this.sideEffect.configuration.reviews.length - 1].id;

        this.selectedReviewTransition = { key: "-1", name: "...", outgoingRules: [], sideEffects: [] };
        this.sideEffect.configuration.reviews.push(this.selectedReview);
    }

    editReview(index: number) {
        this.showWarning = false;
        this.selectedReview = this.sideEffect.configuration.reviews[index];

        if (this.selectedReview.transitionId) {
            this.changeTransition(this.selectedReview.transitionId);
        }
    }

    deleteReview(index: number): void {
        this.sideEffect.configuration.reviews.splice(index, 1);
    }

    workOrderTypeChanged(): void {
        console.log(this.selectedWorkOrderType);
    }

    generateDefaultRule(): Rule {
        return {
            ruleId: genId(),
            name: "Review Due Date",
            expression: "",
            key: undefined,
            message: ""
        } as Rule;
    }
}